import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';

import {
  aboutSectionStyles,
  gridWrapperStyles,
  textColumnStyles,
  titleStyles,
  subtitleStyles,
  paragraphStyles,
  highlightsGridStyles,
  highlightItemStyles,
  ctaStyles,
  imageColumnStyles,
  imageInnerStyles,
  iconCircleStyles,
} from '../styles/About.js';

import { secondaryButtonStyles } from '../styles/Base';

import scrollToSection from '../utils/scrollToSection';

import {
  ABOUT_SECTION_ID,
  DEFAULT_TITLE,
  DEFAULT_SUBTITLE,
  DEFAULT_PARAGRAPHS,
  DEFAULT_HIGHLIGHTS,
  ABOUT_IMAGE,
  ICON_MAP,
} from '../data/About';

import { prefillContactMessage } from '../utils/contactHelper.js';

const About = ({
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
  paragraphs = DEFAULT_PARAGRAPHS,
  highlights = DEFAULT_HIGHLIGHTS,
  image = ABOUT_IMAGE,
}) => {
  return (
    <Box
      id={ABOUT_SECTION_ID}
      component="section"
      sx={aboutSectionStyles}
      aria-labelledby="about-heading"
    >
      <Container maxWidth="xl" disableGutters>
        <Box sx={gridWrapperStyles}>
          {/* Text Column */}
          <Box sx={{ ...textColumnStyles, order: { xs: 2, md: 1 } }}>
            <Typography id="about-heading" component="h2" sx={titleStyles}>
              {title}
            </Typography>

            <Typography component="h3" sx={subtitleStyles}>
              {subtitle}
            </Typography>

            {paragraphs.map((p, i) => (
              <Typography key={i} sx={paragraphStyles} paragraph>
                {p}
              </Typography>
            ))}

            {/* Highlights */}
            <Box sx={highlightsGridStyles} aria-hidden>
              {highlights.map((h, idx) => (
                <Box key={idx} sx={highlightItemStyles}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={iconCircleStyles}>{ICON_MAP[h.label]}</Box>
                    <Box>
                      <Typography
                        component="div"
                        sx={{
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {h.label}
                      </Typography>
                      <Typography
                        component="div"
                        sx={{
                          color: 'grey.700',
                          fontSize: '0.85rem',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {h.value}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* CTA Buttons */}
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={ctaStyles}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => prefillContactMessage()}
                sx={secondaryButtonStyles}
              >
                Contact Us
              </Button>

              <Button
                variant="outlined"
                size="large"
                onClick={() => scrollToSection('service-container')}
                sx={secondaryButtonStyles}
              >
                Our Services
              </Button>
            </Stack>
          </Box>

          {/* Image Column */}
          <Box sx={{ ...imageColumnStyles, order: { xs: 1, md: 2 } }}>
            <Box
              component="img"
              src={image}
              alt="Brand mockup"
              sx={imageInnerStyles}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default About;
